// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.labeled-element {
  display: flex;
  flex-direction: column;
  gap: calc(var(--dialog-element-gap) / 2);
  padding: 0;
  margin: 0;
  width: 100%;
}

.labeled-element-horizontal {
  flex-direction: row;
  align-items: center;

  > .labeled-element-label {
    flex-grow: 1;
  }
}

.labeled-element-label {
  font-size: var(--font-size-l);
  white-space: nowrap;
}

.labeled-element-content > input[type="text"] {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/labelled-element/LabelledElement.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,UAAU;EACV,SAAS;EACT,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;;EAEnB;IACE,YAAY;EACd;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".labeled-element {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--dialog-element-gap) / 2);\n  padding: 0;\n  margin: 0;\n  width: 100%;\n}\n\n.labeled-element-horizontal {\n  flex-direction: row;\n  align-items: center;\n\n  > .labeled-element-label {\n    flex-grow: 1;\n  }\n}\n\n.labeled-element-label {\n  font-size: var(--font-size-l);\n  white-space: nowrap;\n}\n\n.labeled-element-content > input[type=\"text\"] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
